import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-flower-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">樱花漫画</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              樱花漫画网致力于为广大漫画爱好者提供海量韩漫、日漫、国漫免费全集下拉式阅读服务，每日更新热门漫画，支持手机和电脑在线观看。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-foreground-600"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="/category/korean" className="hover:text-primary-500 transition-colors cursor-pointer">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/korean" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">韩漫专区</Link></li>
              <li><Link to="/category/japanese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">日漫专区</Link></li>
              <li><Link to="/category/chinese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">国漫专区</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">全部漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="/about" className="hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><a href="/about#features" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">特色功能</a></li>
              <li><a href="/about#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['恋爱', '热血', '奇幻', '武侠', '校园', '搞笑', '穿越', '悬疑'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 樱花漫画 yinghuamanhua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}